{
  "$id": "module://job-scheduler",
  "$schema": "wealthlane://schemas/domain",
  "title": "Job Scheduler",
  "description": "Scheduled task create/edit — ScheduleItemDetailDto field catalog (flat properties)",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "name": {
      "type": "string",
      "title": "Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "noBlank": true,
      "maxLength": 500,
      "adapterProps": { "rows": 4 }
    },
    "recurrenceStartDate": {
      "type": "string",
      "title": "Start Date",
      "widget": "date"
    },
    "recurrenceStartTime": {
      "type": "string",
      "title": "Start Time",
      "format": "HH:mm",
      "widget": "time",
      "adapterProps": {
        "step": 900,
        "timeIntervals": 15,
        "format": "h:mm aa",
        "placeholder": "HH:MM",
        "calendarIcon": "access_time",
        "timeCaption": "Time"
      }
    },
    "recurrenceTypeId": {
      "type": "string",
      "title": "Recurrence",
      "widget": "select",
      "adapterProps": {
        "actionId": "OPEN_JOB_SCHEDULER_CUSTOM_RECURRENCE",
        "reselectOptionLabel": "Custom"
      }
    },
    "recurrenceStartWeekdayHint": {
      "type": "string",
      "title": "",
      "widget": "label",
      "adapterProps": {
        "hideLabel": true,
        "variant": "body-field"
      }
    },
    "recurrenceDisplayText": {
      "type": "string",
      "title": "",
      "widget": "label",
      "adapterProps": {
        "hideLabel": true,
        "variant": "body-xs",
        "style": {
          "color": "var(--ui-status-info)",
          "fontStyle": "italic"
        }
      }
    },
    "timeZone": {
      "type": "string",
      "title": "Timezone",
      "widget": "select"
    },
    "cronExpression": {
      "type": "string",
      "title": "Cron",
      "widget": "hidden"
    },
    "recurrenceStartDateAnchor": {
      "type": "string",
      "title": "Start date anchor",
      "widget": "hidden"
    },
    "repeatEvery": {
      "type": "number",
      "title": "Repeat every",
      "widget": "number",
      "minimum": 1,
      "adapterProps": {
        "labelOrientation": "horizontal",
        "controlWidth": "5rem"
      }
    },
    "repeatUnit": {
      "type": "string",
      "title": "",
      "widget": "select",
      "adapterProps": { "controlWidth": "7rem" }
    },
    "repeatOnDays": {
      "type": "array",
      "title": "Repeat on",
      "widget": "weekday-toggle",
      "items": { "type": "string" }
    },
    "endType": {
      "type": "string",
      "title": "",
      "widget": "radio",
      "options": [
        { "label": "Never", "value": "never" },
        { "label": "On", "value": "on" },
        { "label": "After", "value": "after" }
      ],
      "adapterProps": { "layout": "vertical" }
    },
    "endOn": {
      "type": "string",
      "title": "",
      "widget": "date"
    },
    "occurrencesLimit": {
      "type": "number",
      "title": "",
      "widget": "number",
      "minimum": 1,
      "adapterProps": { "endAddon": "occurrences" }
    },
    "taskTypeId": {
      "type": "string",
      "title": "Task Type",
      "widget": "select"
    },
    "taskDetailsName": {
      "type": "string",
      "title": "Task Details Name",
      "widget": "hidden"
    },
    "taskDetailId": {
      "type": "string",
      "title": "Custom Report",
      "widget": "select"
    },
    "responseDetails": {
      "type": "string",
      "widget": "hidden"
    },
    "awardTypeId": {
      "$ref": "module://release#properties/releasePlanTypeCategoryId"
    },
    "grantIds": {
      "$ref": "module://release#properties/automationGrantIds"
    },
    "settlementTypeIds": {
      "$ref": "module://settlement#/$defs/settlementTypeIds"
    },
    "timeInterval": {
      "type": "number",
      "title": "Time Interval",
      "widget": "number",
      "minimum": 0,
      "adapterProps": {
        "tooltip": "in minutes"
      }
    },
    "configuration": {
      "type": "array",
      "title": "Configuration",
      "widget": "multi-select",
      "items": { "type": "string" },
      "adapterProps": {
        "displayOrderDisableGate": true
      }
    },
    "taskExecutionDtoId": {
      "type": "string",
      "title": "Task execution DTO id",
      "widget": "hidden"
    },
    "reportName": {
      "type": "string",
      "widget": "hidden"
    },
    "OPEN_REPORT_DESIGNER": {
      "type": "action-button",
      "label": "View report",
      "icon": "visibility",
      "variant": "secondary"
    }
  }
}
